import React, { useEffect, useState } from "react";
import "./DataloftWidget.scss";

const DataloftWidget = ({ widgetcode }) => {
  const [widgetHtml, setHtml] = useState("");

  useEffect(() => {
    fetch(widgetcode)
      .then((res) => res.text())
      .then((data) => {
        // Use regex to strip <meta> and <title> tags
        const cleaned = data
          .replace(/<meta[^>]*>/gi, "")     // remove all <meta ...>
          .replace(/<title[^>]*>.*?<\/title>/gi, ""); // remove <title>...</title>

        setHtml(cleaned);
      })
      .catch((err) => console.error("Widget fetch error:", err));
  }, [widgetcode]);

  return (
    <div className="office-dataloft-widget">
      <div className="container">
        <div
          className="dataloft-html-widget"
          dangerouslySetInnerHTML={{ __html: widgetHtml }}
        />
      </div>
    </div>
  );
};

export default DataloftWidget;